import {AIMarkingBadgeProps} from "../types/AIMarkingBadgeProps";
import {AIMarkingType} from "../types/AIMarkingType";
import {getAIMarkingAsset} from "../utils/get_ai_marking_asset";

const AI_MARKING_ALT_TEXT: Record<AIMarkingType, string> = {
    ai: "Oznaczenie treści AI",
    "ai-generated": "Treść wygenerowana przez AI",
    "ai-modified": "Treść zmodyfikowana przez AI"
};

export const AIMarkingBadge = (props: AIMarkingBadgeProps) => {
    const {type = "ai", color = "black", transparent = false, alt, className} = props;

    const src = getAIMarkingAsset(type, color, transparent);

    return <img src={src} alt={alt ?? AI_MARKING_ALT_TEXT[type]} className={className} />;
};
import {AIMarkingBadgeProps} from "../types/AIMarkingBadgeProps";
import {AIMarkingType} from "../types/AIMarkingType";
import {getAIMarkingAsset} from "../utils/get_ai_marking_asset";

const AI_MARKING_ALT_TEXT: Record<AIMarkingType, string> = {
    ai: "Oznaczenie treści AI",
    "ai-generated": "Treść wygenerowana przez AI",
    "ai-modified": "Treść zmodyfikowana przez AI"
};

export const AIMarkingBadge = (props: AIMarkingBadgeProps) => {
    const {type = "ai", color = "black", transparent = false, alt, className} = props;

    const src = getAIMarkingAsset(type, color, transparent);

    return <img src={src} alt={alt ?? AI_MARKING_ALT_TEXT[type]} className={className} />;
};
